import React from 'react';
import { useField } from 'formik';
import styled, { CSSProperties } from 'styled-components/macro';

import { FormikErrorMessage } from './FormikErrorMessage';
import { FormikLabel } from './FormikLabel';
import { Flex, FlexProps } from '../styles/layout';

const Textarea = styled.textarea`
  width: 100%;
  height: 100px;
  padding: 8px 12px;
  min-height: 100px;
  max-height: 300px;
  border-radius: 4px;
  box-sizing: border-box;
  border: solid 1px #d0d3d9;
  &:focus {
    outline: none;
    border: solid 1px ${({ theme }) => theme.colors.neutral[40]};
  }
`;

interface CustomTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  label: string;
  isRequired: boolean;
  extendStyles?: {
    errorWrapper?: CSSProperties;
    labelStyles?: CSSProperties;
    inputWrapper?: FlexProps;
    mainWrapper?: FlexProps;
  };
}

export const FormikTextAreaField = ({
  label,
  isRequired,
  extendStyles,
  ...props
}: CustomTextareaProps) => {
  const [field, meta] = useField(props);
  return (
    <Flex {...extendStyles?.mainWrapper} gap='4px'>
      <FormikLabel
        label={label}
        name={props.name}
        isRequired={isRequired}
        disabled={!!props.disabled}
        labelStyles={extendStyles?.inputWrapper}
      />
      <Flex {...extendStyles?.inputWrapper} gap='4px'>
        <Textarea {...field} {...props} id={props.name} />
        <FormikErrorMessage meta={meta} extendStyles={extendStyles} />
      </Flex>
    </Flex>
  );
};
